function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 1.667C9.875 1.667 1.667 9.875 1.667 20c0 10.125 8.208 18.333 18.333 18.333 10.125 0 18.333-8.208 18.333-18.333C38.333 9.875 30.125 1.667 20 1.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.877 21.513l-.258 6.122-1.092-.018.175-4.183L10 30.136l-.817-.817 6.644-6.645-4.067.136-.008-1.092 6.125-.205zm11.39-12.287l.818.817-6.644 6.644 4.066-.135.01 1.092-6.126.204.258-6.121 1.091.018-.174 4.183 6.702-6.702z"
}));
function SvgMoreViewsMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgMoreViewsMenuClose;